<template>
  <div class="w-full">
    <div class="flex items-center justify-between w-full">
      <div class="flex items-center">
        <i class="icon-discussion ml-2 mr-12" />

        <div class="leading-tight">
          <div class="text-app-color truncate font-semibold">{{ item.title }}</div>
        </div>
      </div>

      <div
        class="rotate-icon opacity-0 group-hover:opacity-100 anim-opacity"
        :class="{'opacity-100': activeIndex}"
      >
        <i class="icon-arrow-up text-19 font-bold text-dark-600" />
      </div>
    </div>
    <!-- eslint-disable vue/no-v-html -->
    <div v-if="highlight.length > 0" class="highlight text-grey-250 ml-30">
      <span v-for="(h, index) in highlight" :key="h + index" v-html="h" />
    </div>
  </div>
</template>

<script>
import { getHighlightedItems } from '@/core/helper-functions'
import { computed, defineComponent } from 'vue'

export default defineComponent({
  props: {
    item: Object,
    activeIndex: Boolean,
    query: String
  },

  setup (props) {
    const highlight = computed(() => {
      let items = []

      if (props.item.highlight.subTitle) {
        items = [props.item.highlight.subTitle]
      }

      if (props.query && props.item.content && props.item.highlight.content) {
        items.push(...getHighlightedItems(props.item.content, props.query))
      }

      return items
    })

    return {
      // ref
      // data
      // computed
      highlight
      // function
    }
  }
})
</script>
